export const LoadingProfilePictuture = ({ profile }: { profile: string }) => {
    return (
        <div className="relative w-48 h-48 flex items-center justify-center">
            <div className="absolute w-full h-full border-8 border-grayLight border-t-primary rounded-full animate-spin" />
            <img
                className="w-44 h-44 object-cover rounded-full select-none"
                src={profile}
                draggable={false}
                alt="loading-profile"
            />
        </div>
    )
}